export default "__VITE_ASSET__O8F$bses__"